// extracted by mini-css-extract-plugin
export default {"modalZ":"100001","headerHeight":"80px","root":"to_kT","tablet":"EgfFB","container":"rfCvW","title":"_Kh7p","install":"xtlbk","mobile":"VIk7A","smallMobile":"r86Lp","close":"_Oe2S"};